import React from "react";
import Navbar from "../../components/AppDrawer/Navbar";
import Screen1 from "./Screen1";

function Dashboard() {
  return (
    <div>
      <Navbar />
      <Screen1/>
    </div>
  );
}

export default Dashboard;
